import moment from 'moment'
import { createAppSlice } from 'app/createAppSlice'

const date = new Date()
const y = date.getFullYear()
const m = date.getMonth()
const firstDay = new Date(y, m, 1)
const lastDay = new Date(y, m, date.getDate())

const initialState = {
  tag: {
    size: 10,
    page: 0,
    from: firstDay.toISOString(),
    to: lastDay.toISOString(),
    sortby: undefined,
    sortdir: undefined,
    s: undefined,
    memberUserId: undefined,
  },
  isOpenModal: false,
  loading: false,
}

export const attendanceSummarySlice = createAppSlice({
  name: 'attendanceSummary',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    toggleModal: create.reducer((state) => {
      state.isOpenModal = !state.isOpenModal
    }),
  }),
})

export const { toggleSidebar, toggleModal, setFetchOption, toggleModalTolak } =
  attendanceSummarySlice.actions

export default attendanceSummarySlice.reducer
